import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'role_display'
})
export class RolePipe implements PipeTransform {

	roles = [
		{ "key": "ROLE_ACCOUNT_ADMIN", "value": "Account Admin" },
		//{ "key": "ROLE_ACCOUNT_MANAGER", "value": "Account Manager" },
		{ "key": "ROLE_ACCOUNT_DEVELOPER", "value": "Developer" },
		{ "key": "ROLE_FLEET_OPERATOR", "value": "Fleet Operator" },
		{ "key": "ROLE_RENTER", "value": "Renter" },
		{ "key": "ROLE_FMC_DRIVER", "value": "Driver" },
		{ "key": "ROLE_INSTANCE_QA_USER", "value": "QA User" },
		{ "key": "ROLE_B2C_OWNER", "value": "Owner" },
		{ "key": "ROLE_B2C_DRIVER", "value": "Driver" },
		{ "key": "ROLE_B2C_PROSPECT", "value": "Prospect" },
		{ "key": "ROLE_ACCOUNT_FINANCE_USER", "value": "Finance Manager" },
		{ "key": "ROLE_FMC_AGENT", "value": "Agent" }
	];

	isFleetDemoAppRole(role) {
		if (role == "ROLE_FLEET_OPERATOR" || role == "ROLE_RENTER")
			return true;

		return false;
	}

	transform(value: any, args: string[]): any {
		if (!value) {
			return '';
		} else {
			var valueToDisplay = value;

			for (var i = 0; i < this.roles.length; i++) {
				if (this.roles[i].key == value) {
					valueToDisplay = this.roles[i].value;
					break;
				}
			}
			return valueToDisplay;
		}

	}

}
